import { render, staticRenderFns } from "./CommonBgColor.vue?vue&type=template&id=7a49d228&scoped=true"
import script from "./CommonBgColor.vue?vue&type=script&lang=js"
export * from "./CommonBgColor.vue?vue&type=script&lang=js"
import style0 from "./CommonBgColor.vue?vue&type=style&index=0&id=7a49d228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a49d228",
  null
  
)

export default component.exports